import { Field } from "formik";
import { Form } from "react-bootstrap";
import * as Yup from "yup";
// SubForms
import { NameAndContactSubForm, Schema as NameAndContactSchema } from '../subforms/NameAndContact';
import { PersonalDataSubForm, Schema as PersonalDataSchema } from '../subforms/PersonalData';
import { DocumentsSubForm, Schema as DocumentsSchema } from '../subforms/Documents';

export const LeicaStandardSchema = (settings) => (
    Yup.object()
        .concat(NameAndContactSchema(settings))
        .concat(PersonalDataSchema(settings))
        .concat(DocumentsSchema(settings))
);

export const LeicaStandard = (props) => {
    const { colors, settings } = props;
    return (
        <>
            <Form.Text muted>Die im Folgenden mit * markierten Felder sind Pflichtfelder.</Form.Text>
            <Field component={NameAndContactSubForm} colors={colors} settings={settings} />
            <Field component={PersonalDataSubForm} colors={colors} settings={settings} />
            <Field component={DocumentsSubForm} colors={colors} settings={settings} />
        </>
    );
}